export type UserType = 'STANDARD' | 'PRO';
export type State = null | UserType;

const initialState: State = null;

export const UPDATE_USER_TYPE = 'UPDATE_USER_TYPE';

export const updateUserType = (payload: State) => ({
    type: UPDATE_USER_TYPE,
    payload,
});

export default (state: State = initialState, action): State =>
    action.type === UPDATE_USER_TYPE && action.payload ? action.payload : state;
